import React from 'react'

import DefaultLogo from '../../assets/skillfit.svg'
import { useBranding } from '../../branding'

export default React.memo(function SkillfitLogo({ className }: { className?: string }) {
  const { logoComponent } = useBranding()

  return React.createElement(logoComponent || DefaultLogo, { className } as any)
})
